module.exports = __webpack_public_path__ + "img/061b630d1732fe296153844f069ef1d4.png";